import { FeedItem } from '../../Api'

export const getPartnerLabel = (feedItem: FeedItem) => {
  if (feedItem.partnerId) return feedItem.partnerId
  if (feedItem.tags?.find((tag) => tag === 'wll')) return 'WLL'
  return null
}

export const deduplicateFeedItems = (items: FeedItem[]): FeedItem[] => {
  const seen = new Set<string>()
  return items.filter((item) => {
    if (!item.id) {
      return true
    }
    if (seen.has(item.id)) {
      return false
    }
    seen.add(item.id)
    return true
  })
}
